import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const SvgIcon = (props: SvgIconT.Props) => {
  const { containerProps = {}, size, color, className = '', style = {}, innerRef, ...rest } = props;
  const fill = !color && !props.fill ? '#8DC7E9' : props.fill;
  const width = !size && !props.width ? 24 : props.width;
  const height = !size && !props.height ? 24 : props.height;
  const { cssClassName } = convertPropToCssClassName('icon', className, {
    size,
    color,
  });
  return (
    <span
      ref={innerRef}
      className={cssClassName}
      {...rest}
      {...containerProps}
      style={{
        width,
        height,
        ...style,
      }}
    >
      <svg
        width={width && String(width)}
        height={height && String(height)}
        style={{
          width,
          height,
        }}
        fill={fill}
        viewBox="0 0 24 24"
      >
        <path
          d="M6.196875 0H0v6.196875C.8775 3.22125 3.22125.8775 6.196875 0zm7.501875 16.539375c-1.419375.9-3.10125 1.425-4.905 1.425-4.1625-.001875-7.674375-2.775-8.79375-6.57375V24h21.1614375L13.69875 16.539375zM8.79375 3.375c2.9926875 0 5.41875 2.4260625 5.41875 5.41875s-2.4260625 5.41875-5.41875 5.41875S3.375 11.7864375 3.375 8.79375 5.8010625 3.375 8.79375 3.375zm9.16875 5.41875c0 1.903125-.579375 3.669375-1.57125 5.13375L24 21.53625V0H11.390625c3.79875 1.119375 6.571875 4.63125 6.571875 8.79375z"
          fill="#8DC7E9"
          fillRule="evenodd"
        />
      </svg>
    </span>
  );
};

export default SvgIcon;
